import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { USER_ROLES } from '@shared/constant/shared.constant';
import { DriverService as driverPaymentService } from 'src/app/shared/components/driver/services/driver.service';
import { Router } from '@angular/router';
import { autoUnsubWith } from '@shared/services/utility.abstract';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';
@Component({
  selector: 'app-add-payment-method',
  templateUrl: './add-payment-method.component.html',
  styleUrls: ['./add-payment-method.component.scss'],
})
export class AddPaymentMethodComponent implements OnInit {
  readonly destroyRef = inject(DestroyRef);
  display: boolean = true;
  driverId: string;
  paymentUrl: string;
  userRole = USER_ROLES;
  bookingFor: string;
  role: string = '';

  constructor(
    public readonly ref: DynamicDialogRef,
    public readonly config: DynamicDialogConfig,
    private readonly router: Router,
    private readonly driverPaymentService: driverPaymentService,
    private readonly encryptStorage: EncryptionStorageService
  ) {}

  ngOnInit() {
    this.bookingFor = this.router.url.includes('create-group-operator-booking') ? 'group operator' : 'parker';
    this.role = this.encryptStorage.getItem('roleName');
  }

  get roleType() {
    return this.role === this.userRole.SUPER_ADMIN ? 'super-admin' : 'manager';
  }

  get isSafari() {
    const userAgent = navigator.userAgent.toLowerCase();
    return /safari/.test(userAgent) && !/chrome/.test(userAgent);
  }

  addPaymentMethod() {
    let DriverId = this.config.data?.driverInfo?.driverId;
    let bookingRole = this.config.data?.user;
    const request = {
      driverId: DriverId,
      isBookingPopup: true,
    };
    this.driverPaymentService
      .addPaymentMethodInRecurringCase(request)
      .pipe(autoUnsubWith(this.destroyRef))
      .subscribe({
        next: (response) => {
          let paymentMethodRoutelink = response.data as string;
          this.closeDialog('close');
          if (this.isSafari) {
            if (this.role === this.userRole.DRIVER) {
              this.router.navigate(['driver/profile'], {
                queryParams: { tab: 2 },
              });
            } else if (this.role === this.userRole.GROUP_USER) {
              this.router.navigate(['group-operator/profile'], {
                queryParams: { tab: 1 },
              });
            } else {
              this.router.navigate([`${this.roleType}/${bookingRole}`], {
                queryParams: { id: DriverId, tab: 0, iTab: 2 },
              });
            }
          } else {
            window.open(
              paymentMethodRoutelink,
              'stripePopup',
              'width=500,height=600'
            );
          }
        },
        error: () => {},
      });
  }

  closeDialog(buttonName: string) {
    this.ref.close(buttonName);
  }
}
